(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["eligible-postcodes"] && !Shopify.designMode) return;
  try {
    class DeliveryPostcodeLookup extends HTMLElement {
    connectedCallback() {
      this.form = this.querySelector('[data-postcode-form]');
      this.postcodeInput = this.querySelector('[data-postcode-input]');
      this.result = this.querySelector('[data-postcode-result]');
      this.filterInput = this.querySelector('[data-table-filter]');
      this.tableStatus = this.querySelector('[data-table-status]');
      this.pageStatus = this.querySelector('[data-page-status]');
      this.previousButton = this.querySelector('[data-page-previous]');
      this.nextButton = this.querySelector('[data-page-next]');
      this.showAllButton = this.querySelector('[data-show-all]');
      this.rows = Array.from(this.querySelectorAll('[data-table-body] tr')).map((element) => ({
        element,
        postcode: element.dataset.postcode,
        suburb: element.dataset.suburb,
        distance: element.dataset.distance
      }));
      this.filteredRows = this.rows;
      this.currentPage = 1;
      this.pageSize = 25;
      this.showAll = false;

      this.form.addEventListener('submit', (event) => {
        event.preventDefault();
        this.checkPostcode();
      });
      this.postcodeInput.addEventListener('input', () => {
        this.postcodeInput.value = this.postcodeInput.value.replace(/\D/g, '').slice(0, 4);
      });
      this.filterInput.addEventListener('input', () => this.filterTable());
      this.previousButton.addEventListener('click', () => this.changePage(-1));
      this.nextButton.addEventListener('click', () => this.changePage(1));
      this.showAllButton.addEventListener('click', () => this.toggleShowAll());

      this.renderTable();
    }

    checkPostcode() {
      const postcode = this.postcodeInput.value.trim();
      if (!/^\d{4}$/.test(postcode)) {
        this.renderMessage('error', this.dataset.invalidMessage);
        return;
      }

      const matches = this.rows.filter((row) => row.postcode === postcode);
      if (!matches.length) {
        const copy = this.dataset.notFoundCopy.replace('[postcode]', postcode);
        this.renderMessage('error', this.dataset.notFoundTitle, copy);
        return;
      }

      const copyTemplate = matches.length === 1 ? this.dataset.foundCopyOne : this.dataset.foundCopyMany;
      const copy = copyTemplate
        .replace('[count]', String(matches.length))
        .replace('[postcode]', postcode);
      this.renderMessage('success', this.dataset.foundTitle, copy, matches);
    }

    renderMessage(type, title, copy = '', matches = []) {
      this.result.replaceChildren();
      this.result.hidden = false;
      this.result.classList.toggle('is-error', type === 'error');

      const heading = document.createElement('p');
      heading.className = 'eligible-postcodes__result-heading';
      const mark = document.createElement('span');
      mark.className = 'eligible-postcodes__result-mark';
      mark.setAttribute('aria-hidden', 'true');
      mark.textContent = type === 'error' ? '!' : '✓';
      const headingText = document.createElement('span');
      headingText.textContent = title;
      heading.append(mark, headingText);
      this.result.append(heading);

      if (copy) {
        const paragraph = document.createElement('p');
        paragraph.textContent = copy;
        this.result.append(paragraph);
      }

      if (matches.length) {
        const matchList = document.createElement('div');
        matchList.className = 'eligible-postcodes__matches';
        matches.forEach((match) => {
          const item = document.createElement('div');
          item.className = 'eligible-postcodes__match';
          const suburb = document.createElement('span');
          suburb.textContent = match.element.cells[1].textContent.trim();
          const distance = document.createElement('span');
          distance.textContent = this.dataset.distanceLabel.replace('[distance]', match.distance);
          item.append(suburb, distance);
          matchList.append(item);
        });
        this.result.append(matchList);
      }
    }

    filterTable() {
      const query = this.filterInput.value.trim().toLowerCase();
      this.filteredRows = this.rows.filter((row) => row.postcode.includes(query) || row.suburb.includes(query));
      this.currentPage = 1;
      this.showAll = false;
      this.renderTable();
    }

    changePage(direction) {
      const totalPages = Math.max(1, Math.ceil(this.filteredRows.length / this.pageSize));
      this.currentPage = Math.min(totalPages, Math.max(1, this.currentPage + direction));
      this.renderTable();
      this.querySelector('.eligible-postcodes__table-wrap').scrollIntoView({ behavior: 'smooth', block: 'start' });
    }

    toggleShowAll() {
      this.showAll = !this.showAll;
      this.currentPage = 1;
      this.renderTable();
    }

    renderTable() {
      const total = this.filteredRows.length;
      const totalPages = Math.max(1, Math.ceil(total / this.pageSize));
      const start = this.showAll ? 0 : (this.currentPage - 1) * this.pageSize;
      const end = this.showAll ? total : Math.min(start + this.pageSize, total);
      const visible = new Set(this.filteredRows.slice(start, end).map((row) => row.element));

      this.rows.forEach((row) => {
        row.element.hidden = !visible.has(row.element);
      });

      if (total === 0) {
        this.tableStatus.textContent = this.dataset.noTableResults;
      } else {
        this.tableStatus.textContent = this.dataset.showingTemplate
          .replace('[start]', String(start + 1))
          .replace('[end]', String(end))
          .replace('[total]', String(total));
      }

      this.pageStatus.textContent = this.showAll ? '' : this.dataset.pageLabel
        .replace('[current]', String(this.currentPage))
        .replace('[total]', String(totalPages));
      this.previousButton.disabled = this.showAll || this.currentPage <= 1;
      this.nextButton.disabled = this.showAll || this.currentPage >= totalPages;
      this.showAllButton.textContent = this.showAll ? this.dataset.showPagesLabel : this.dataset.showAllLabel;
      this.querySelector('[data-pagination]').hidden = total <= this.pageSize;
    }
  }

  if (!customElements.get('postcode-lookup')) {
    customElements.define('postcode-lookup', DeliveryPostcodeLookup);
  }
  } catch(e) { console.error(e); }
})();

})();
